import script from "./QRScannerNew.vue?vue&type=script&setup=true&lang=js"
export * from "./QRScannerNew.vue?vue&type=script&setup=true&lang=js"

import "./QRScannerNew.vue?vue&type=style&index=0&id=011e0178&lang=css"

const __exports__ = script;

export default __exports__